import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import api from '../services/api';

// Weekly walkaround checks (Samsara) against the Fleet Master. Worked out on the
// tech server, which also runs the hourly Samsara sync.
export function useWalkarounds(week) {
  return useQuery({
    queryKey: ['walkarounds', week || 'current'],
    queryFn: async () => (await api.get('/api/walkarounds', { params: week ? { week } : {} })).data,
    staleTime: 60000,
  });
}

// Pull the latest walkarounds from Samsara now, rather than waiting for :20.
export function useSyncWalkarounds() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async () => (await api.post('/api/walkarounds/sync')).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['walkarounds'] }),
  });
}
